"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

require("./Spinner.scss");

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["color", "size", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** The size of the spinner */
  size: (0, _propTypes.oneOf)(['small', 'medium', 'large']),

  /** Override the color of the spinner. By default it will use the text color of the parent. */
  color: (0, _propTypes.oneOf)(['red', 'white', 'black', 'anthracite']),

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {
  size: 'small'
};
/**
 * @deprecated Use [`<ProgressRadial isIndeterminate />`](/#/Components/Visual/ProgressRadial) instead.
 * */

var Spinner = function Spinner(_ref) {
  var color = _ref.color,
      size = _ref.size,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = (0, _classnames.default)('rds-spinner', {
    'rds-spinner--small': size === 'small',
    'rds-spinner--medium': size === 'medium',
    'rds-spinner--large': size === 'large',
    'rds-spinner--red': color === 'red',
    'rds-spinner--anthracite': color === 'anthracite',
    'rds-spinner--black': color === 'black',
    'rds-spinner--white': color === 'white'
  }, className);
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: componentClassNames
  }, rest));
};

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
var _default = Spinner;
exports.default = _default;